import type { Product, ProductDefinitionDto } from '~/common/model/capabilities'

export const toProduct = ({ label, key, group = 'unknown' }: ProductDefinitionDto): Product => ({
  label,
  value: key,
  isReturnProduct: key.includes('RETURN'),
  group,
})
